<template>
    <layout-component>
        <div class="banner banner-contact">
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <p
                            class="h1-style left-bullet"
                            v-html="$t('address')"
                        ></p>
                        <ul class="contact-links">
                            <li>
                                <a href="tel:+352 58 77 11 535" class="btn-link"
                                    >+352 58 77 11 535</a
                                >
                            </li>
                            <li class="mt-1 mt-sm-0">
                                <a
                                    href="mailto:info@sonotron.lu"
                                    class="btn-link"
                                    >info@sonotron.lu</a
                                >
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8 offset-md-2 pb-3 pt-3 pb-md-4 pt-md-4">
                        <b-img
                            src="/storage/img/pic/1535-map.webp"
                            alt="1535 map"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8 offset-md-2 how-to-come">
                        <div class="row pt-2 pb-3">
                            <div class="col-md-5">
                                <p class="h4-style bottom-cut">
                                    {{ "by-car-title" | t }}
                                </p>
                            </div>
                            <div class="col-md-7">
                                <p v-html="$t('by-car-text')"></p>
                                <a
                                    href="https://www.google.com/maps/dir/Pl.+des+Alli%C3%A9s,+4684+Differdange,+Luxembourg/''/@49.5230207,5.8922597,14z/data=!4m14!4m13!1m5!1m1!1s0x47eaca5e3b35f313:0xe89b563e9a05eaab!2m2!1d5.8999755!2d49.5207389!1m5!1m1!1s0x47eaca60a9ff0c37:0xde33e43c4440de66!2m2!1d5.8996311!2d49.5205483!3e4"
                                    target="_blank"
                                    class="btn-link mt-1"
                                    >{{ "by-car-btn" | t }}</a
                                >
                            </div>
                        </div>

                        <div class="row pb-3">
                            <div class="col-md-5">
                                <p class="h4-style bottom-cut">
                                    {{ "by-train-title" | t }}
                                </p>
                            </div>
                            <div class="col-md-7">
                                <p v-html="$t('by-train-text')"></p>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-5">
                                <p class="h4-style bottom-cut">
                                    {{ "by-bus-title" | t }}
                                </p>
                            </div>
                            <div class="col-md-7">
                                <p v-html="$t('by-bus-text')"></p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </layout-component>
</template>

<script>
export default {
    mounted() {
        $(".title-anim-wrapper:in-viewport").addClass("in-viewport");
    }
};
</script>

<i18n>
  {
    "en": {
      "address": "<span class='title-anim-wrapper'><span class='title-anim td'>115C</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>Rue Emile Mark</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>4620 Differdange</span></span>",
      "by-train-title": "By train",
      "by-train-text": "Luxembourg - Pétange – Rodange: Stop Differdange-Gare<br> Luxembourg - Esch/Alzette - Pétange: Stop Differdange-Gare (7 min. walk)",
      "by-bus-title": "By bus",
      "by-bus-text": "Nearest bus stop: Differdange - Foussbann (1 min. walk)",
      "by-car-title": "By car",
      "by-car-text": "Parking 1535° Creative Hub<br> Parking Place des Alliés (5 min. walk)",
      "by-car-btn": "Plan your route"
    },
    "fr": {
      "address": "<span class='title-anim-wrapper'><span class='title-anim td'>115C</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>Rue Emile Mark</span></span> <span class='title-anim-wrapper'><span class='title-anim td-3'>4620 Differdange</span></span>",
      "by-train-title": "En train",
      "by-train-text": "Ligne CFL <br />Luxembourg - Pétange - Rodange <br />Arrêt Differdange gare (7 min. à pied)",
      "by-train-text": "Luxembourg - Pétange – Rodange: Arrêt Differdange-Gare<br> Luxembourg - Esch/Alzette - Pétange: Arrêt Differdange-Gare (7 min. à pied)",
      "by-bus-title": "En bus",
      "by-bus-text": "Arrêt le plus proche: Differdange - Foussbann (1 min. à pied)",
      "by-car-title": "En voiture",
      "by-car-text": "Parking 1535° Creative Hub<br> Parking Place des Alliés (5 min. à pied)",
      "by-car-btn": "Calculer mon itineraire"
    }
  }

</i18n>
